// extracted by mini-css-extract-plugin
export default {"spinner-background":"loading-spinner_spinner-background__orYVW"};